module.exports = __webpack_public_path__ + "img/pinfl__ru__passport.3d745d7f.png";